// Module
var code = "<section class=\"project-related page-detail-wrapper\"> <div class=\"page-detail\"> <span></span><span></span><span></span><span></span><span></span> </div> <div class=\"container-fluid\"> <h2 class=\"project-related-title\">Outros projetos</h2> </div> <ul data-project-related-list class=\"project-related-list\"> </ul> </section>";
// Exports
export default code;